import { useState } from 'react';

function Dates({ name, label, formData, setFormData }) {
    const [error, setError] = useState('');

    const handleChange = (e) => {
        let input = e.target.value.replace(/\D/g, '');

        // Formatear como dd/mm
        if (input.length >= 3) {
            input = input.slice(0, 2) + '/' + input.slice(2, 4);
        }

        const formatted = input.slice(0, 5);
        setFormData({ ...formData, [name]: formatted });

        // Validar día y mes
        if (formatted.length === 5) {
            const [dd, mm] = formatted.split('/').map(Number);
            if (dd < 1 || dd > 31) {
                setError('Día inválido');
            } else if (mm < 1 || mm > 12) {
                setError('Mes inválido');
            } else {
                setError('');
            }
        } else {
            setError('');
        }
    };

    return (
        <div className='field'>
            <label className='text-xs font-bold uppercase'>
                {label}
                <div className='relative'>
                    <input
                        type='text'
                        name={name}
                        value={formData[name] || ''}
                        onChange={handleChange}
                        placeholder='dd/mm'
                        required
                        style={{
                            border: '2px solid',
                            borderColor: 'transparent',
                        }}
                    />
                </div>
            </label>
            {error && <p className='text-red-500 text-xs mt-1'>{error}</p>}
        </div>
    );
}
export default Dates;